import React from "react";
import Logo from "./Logo";
import "./Section.css";
import {APKLink, GoogleStoreLink, HuaweiLink, SamsungLink, XiaomiLink} from "./Links";

const SectionEn = () => {
  return (
    <section className="app-section">
      <h1>How to Install Tango: A Step-by-Step Guide📲</h1>
      <h5>Go Live. Connect. Enjoy – Anytime, Anywhere!</h5>
      <div className="icon-section">
        <Logo />
        <div className="icon-section__text">
          <span>Written by Tango</span>
          <span>Updated today</span>
        </div>
      </div>
      <p>
        <b>
          Tango is available on multiple platforms, making it easy to go live and enjoy live entertainment anytime, anywhere.
        </b>
      </p>
      <hr />
      <h2>🤖 For Android Users:</h2>
      <p>
        You can download Tango directly from:
      </p>
      <ul>
        <li>
          <GoogleStoreLink text={"Google Play Store"}/>
        </li>
        <li>
          <XiaomiLink/>
        </li>
        <li>
          <HuaweiLink/>
        </li>
        <li>
          <SamsungLink/>
        </li>
      </ul>
      <hr />
      <br />
      <h2> For iOS: </h2>
      <p>
        <b>
          If you previously installed Tango on your iOS device, you can re-download it from the App Store.
        </b>
      </p>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/TQkbk0cvsxE?si=e5ZqM_EWiJe9F01R"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        <b>1. Open the App Store:</b> Enter the App Store on your iOS device.
      </p>
      <p>
        <b>2. Tap on Your Profile Picture</b> in the top right corner of the
        screen to open your Account Settings.
      </p>
      <p>
        <b>3. Go to 'Apps' or 'Purchase History':</b> Scroll through your list
        of previously purchased apps or use the <b>search bar</b> at the top to
        type “Tango.”
      </p>
      <p>
        <b>4. Re-Download Tango:</b> Once you find Tango in the list, tap the
        <b>cloud icon with the arrow</b> next to it to re-download the app.
      </p>
      <p>
        <b>5. Open Tango App</b> after installation and follow the registration
        or sign-in process.
      </p>
      <hr />
      <h2>New to Tango? Easily Add Tango to Your Home Screen for Quick Access</h2>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/iM15aUI94Yo?si=qee02UWPVKEXtDdF"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        <b>1. Open Tango's Website:</b> Open the link <a href="https://tango.me">https://tango.me</a> in your
        mobile browser
      </p>
      <p>
        <b>2. Tap the Share Icon:</b> The square with an upward arrow at the
        bottom of the screen
      </p>
      <p>
        <b>3. Select “Add to Home Screen”</b> from the menu and the Tango
        shortcut will be added to your device's home screen
      </p>
      <p>Once installed, you’re ready to go live, support your favorite creators, and enjoy endless entertainment – all at your fingertips!</p>
      <br/>
      <b>Get started and join the action now! 🎉 </b>
    </section>
  );
};

export default SectionEn;
